if (!customElements.get('section-cart')) {
    class TG_SectionCart extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.element = this;
            this.delegateElement = new themegoal.libs.Delegate(this.element);
            this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
            this.itemCount = this.options['itemCount'];
        
            this._bindEventsListeners();
            this._onExternalCartRefresh = () => this._rerenderCart(false).catch(function (error) {
                console.error('Cart page refresh failed:', error);
            });
            document.addEventListener('cart:refresh', this._onExternalCartRefresh);
            this._loadShippingAmountNotice();
        }

        disconnectedCallback(){
            if(this.delegateElement)this.delegateElement.destroy();
            document.removeEventListener('cart:refresh', this._onExternalCartRefresh);
        }

        _bindEventsListeners() {
            this.delegateElement.on('change', '#CartNote', this._updateCartNote.bind(this));
            this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
            this.delegateElement.on('change', '.CartItem__QuantityNum', this._updateItemQuantity.bind(this));
            this.delegateElement.on('click', '[data-cart-clear-all]', this._openClearAllDialog.bind(this));
            this.delegateElement.on('click', '[data-cart-clear-cancel]', this._closeClearAllDialog.bind(this));
            this.delegateElement.on('click', '[data-cart-clear-confirm]', this._clearAll.bind(this));
            this.delegateElement.on('main-cart:refresh', this._rerenderCart.bind(this, false));
        }

        _beginCartAction(button, loadingText) {
            if (this.actionBusy) return null;
            this.actionBusy = true;

            if (window.RPCartLoading) {
                return { uxState: window.RPCartLoading.beginButton(button, loadingText, null, this.element) };
            }

            document.dispatchEvent(new CustomEvent('theme:loading:start'));
            if (button) button.disabled = true;
            return { button: button };
        }

        _endCartAction(actionState) {
            this.actionBusy = false;
            if (!actionState) return;

            if (actionState.uxState && window.RPCartLoading) {
                window.RPCartLoading.end(actionState.uxState);
            } else {
                if (actionState.button) actionState.button.disabled = false;
                document.dispatchEvent(new CustomEvent('theme:loading:end'));
            }
        }

        _openClearAllDialog(event, target) {
            event.preventDefault();
            var dialog = this.element.querySelector('[data-cart-clear-dialog]');

            if (!dialog || typeof dialog.showModal !== 'function') {
                if (window.confirm('Remove every product and sample from your cart?')) {
                    this._clearAll(null, target);
                }
                return;
            }

            dialog.showModal();
            var cancelButton = dialog.querySelector('[data-cart-clear-cancel]');
            if (cancelButton) cancelButton.focus();
        }

        _closeClearAllDialog(event, target) {
            event.preventDefault();
            var dialog = target.closest('[data-cart-clear-dialog]');
            if (dialog && dialog.open) dialog.close();
        }

        _clearAll(event, target) {
            var _this = this;
            if (event) event.preventDefault();
            target = target || (event && event.target && event.target.closest('[data-cart-clear-confirm]'));

            var actionState = this._beginCartAction(target, 'Removing…');
            if (!actionState) return;

            fetch(window.routes.cartUrl + '/clear.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            }).then(function (response) {
                if (!response.ok) throw new Error('Unable to clear cart');
                return response.json();
            }).then(function (content) {
                _this.itemCount = content['item_count'];
                return _this._rerenderCart(false);
            }).catch(function (error) {
                console.error('Cart clear failed:', error);
            }).finally(function () {
                _this._endCartAction(actionState);
            });
        }
        
        _updateCartNote(event, target) {
            fetch(window.routes.cartUrl + '/update.js', {
                body: JSON.stringify({ note: target.value }),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest' 
                }
            });
        }
        
        _updateItemQuantity(event, target) {
            var _this = this;
        
            document.dispatchEvent(new CustomEvent('theme:loading:start'));
        
            var quantity = null,
                elementToAnimate = null;
        
            //input or + - button
            if (target.tagName === 'INPUT') {
                quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
            } else {
                //+ - 
                quantity = parseInt(target.getAttribute('data-quantity'));
            }
        
            if (quantity === 0) {
                elementToAnimate = target.closest('.CartItem__Wrapper');
            }
        
            fetch(window.routes.cartChangeUrl + '.js', {
                body: JSON.stringify({ id: target.getAttribute('data-line-id'), quantity: quantity }),
                credentials: 'same-origin',
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest' 
                }
            }).then(function (cart) {
                cart.json().then(function (content) {
                    _this.itemCount = content['item_count'];
                    _this._rerenderCart(elementToAnimate);
            
                    document.dispatchEvent(new CustomEvent('theme:loading:end'));
                });
            });
        
            event.preventDefault();
        }
        
        _rerenderCart(elementToAnimate) {
            var _this = this;
        
            return fetch(window.routes.cartUrl + '?timestamp=' + Date.now(), {
                credentials: 'same-origin',
                method: 'GET'
            }).then(function (content) {
                if (!content.ok) throw new Error('Unable to refresh cart');
                return content.text();
            }).then(function (html) {
                if (elementToAnimate) {
                    return new Promise(function (resolve) {
                        themegoal.libs.anime({
                            targets: elementToAnimate,
                            opacity: 0,
                            height: 0,
                            duration: 500,
                            easing: 'easeOutCubic',
                            complete: function() {
                                _this._replaceContent(html);
                                resolve();
                            }
                        });
                    });
                }

                _this._replaceContent(html);
            });
        }
        
        _replaceContent(html) {
            let _this = this;
        
            let tempElement = document.createElement('div');
            tempElement.innerHTML = html;
        
            // The response can cross either direction between an empty cart and
            // a populated cart. Replace the shared content wrapper, not a form
            // that is absent in the empty state.
            this.element.querySelector('.Cart__Content').innerHTML =
                tempElement.querySelector('section-cart .Cart__Content').innerHTML;
            
            let cartResult = JSON.parse(tempElement.querySelector('section-cart').getAttribute('data-section-settings'));
        
            let cartCount = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountBubble')),
            cartText = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountText')),
            cartQuantity = themegoal.helpers.Dom.nodeListToArray(document.querySelectorAll('.CartCountBubble__Count'));
        
            this.itemCount = cartResult['itemCount'];
        
            cartCount.forEach(function (item) {
                if (_this.itemCount === 0) {
                    item.classList.remove('Visible'); 
                } else {
                    item.classList.add('Visible');
                }
            });
        
            cartText.forEach(function (item) {
                if (_this.itemCount === 0) {
                    item.classList.add('Visible'); 
                } else {
                    item.classList.remove('Visible');
                }
            });
        
            cartQuantity.forEach(function (item) {
                item.textContent = _this.itemCount;
                // Keep the screen-reader count (VisuallyHidden sibling) in step too — it was
                // only rendered server-side once, so it otherwise announces a stale count.
                var hidden = item.parentElement.querySelector('span.VisuallyHidden');
                if (hidden) hidden.textContent = _this.itemCount + (_this.itemCount === 1 ? ' item' : ' items');
            });


            this._loadShippingAmountNotice();
        
        }

        _loadShippingAmountNotice(){
            if(this.options["freeShippingThreshold"]){
                let freeShippingElement = this.element.querySelector(".Cart__ShippingAmountNotice");
                let cartForm = this.element.querySelector(".Form--cart");
            
                if(freeShippingElement && cartForm){
                    let cartTotalPrice = cartForm.getAttribute("data-cart-total-price");
                    let cartCurrencySymbol = cartForm.getAttribute("data-cart-currency-symbol");
            
                    cartTotalPrice = parseInt(cartTotalPrice);
            
                    let freeShippingAmount = Math.round(this.options["freeShippingAmount"] * (Shopify.currency.rate || 1));
            
                    if(cartTotalPrice >= freeShippingAmount){
                        freeShippingElement.innerHTML = this.options["freeShippingString"];
                    }else{
                        let freeShippingAmountString = this.options["freeShippingAmountString"];
                        freeShippingAmountString = freeShippingAmountString.replace("remaining__amount", "" + cartCurrencySymbol + (freeShippingAmount - cartTotalPrice)/100);
                        freeShippingElement.innerHTML = freeShippingAmountString;  
                    }
                }
            }
        }
    
    }
    
    customElements.define('section-cart', TG_SectionCart);
}
